import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import endPoints from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../../modules/ajio-fetch/utils';

import { getSafeFunction } from '../../utils/higherOrder';
import { closeAccordion } from '../../actions/shared/accordion';
import { setOOSItemInCart } from '../../cart/actions/cart';
import isNode from '../../modules/ajio-util/isNode';

const _safeFetchGetJSONResHandler = getSafeFunction(fetchGetJSONResHandler);
const _safeCheckStock = getSafeFunction(checkStock);
const _safePaymentURL = getSafeFunction(createPaymentURL);
const _safeFetcher = getSafeFunction(fetcher);
const _tokenReCreateParser = getSafeFunction(tokenReCreateParser);

/**
 * store selected payment option
 * @return {Object} [description]
 */
export function selectedPaymentOption(selectedOption) {
  return {
    type: 'SELECTED_PAYMENT_OPTION',
    selectedOption
  };
}

/**
 * [updatePaymentOption description]
 * @param  {String} selectedOption [description]
 * @return {Function}                [description]
 */
export function updatePaymentOption(selectedOption) {
  return function(dispatch) {
    dispatch(setGateway());
    dispatch(selectedPaymentOption(selectedOption));
  };
}

function setPaymentOption(paymentOptions = {}) {
  return {
    type: 'AVAILABLE_PAYMENT_LIST',
    paymentOptions
  };
}

export function setRedeemType(redeemType = '') {
  return {
    type: 'REDEEM_TYPE',
    redeemType
  };
}

function notAllowedPayment(paymentOption, msg = '') {
  return {
    type: 'DEFAULT_NOT_ALLOWED_PAYMENTS_FROM_LIST',
    paymentOption,
    msg
  };
}

function enableDisabledPayment(paymentOption) {
  return {
    type: 'ENABLE_PAYMENTS_FROM_LIST',
    paymentOption
  };
}

function setGateway(gatewayInfo = {}) {
  return {
    type: 'SET_PAYMENT_GATEWAY',
    gatewayInfo
  };
}

export function updateSubmitStatus(value = false) {
  return {
    type: 'UPDATE_PAYMENT_FORM_SUBMIT_STATUS',
    value
  };
}

export function setOrder(order = {}) {
  return {
    type: 'SET_ORDER',
    order
  };
}
export function getPaymentOptions(requestObj = {}) {
  const {
    request = {},
    isRequestOrginIsBrowser = false,
    pinCode = '',
    cart = {},
    payment = {}
  } = requestObj;
  return dispatch => {
    const { cookies: { C: cartId = '', A: token = '', U: user = '' } = {} } = request;
    let apiEndPoint = `/api/checkout/payment-option`;

    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('layout-loader'));
    } else {
      const { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/checkout/payment-option`;
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ pinCode, cartId, token }),
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          orderSummary: {
            storeCredit: { value = 0 } = {},
            giftWrapCharge: { value: giftWrapAmount = 0 } = {},
            orderTotal: { value: orderValue = 0 } = {},
            jioPrimePoint: { value: JPPValue = 0 } = {}
          } = {}
        } = cart;

        const {
          cod: {
            codAvailable = false,
            hasFwdService = false,
            isCODRestricted = false,
            CODRestrictedMsg = ''
          } = {}
        } = response;
        if (giftWrapAmount > 0 && response.hasOwnProperty('cod')) {
          dispatch(notAllowedPayment('cod'));
        } else if (!hasFwdService) {
          dispatch(notAllowedPayment('cod', "Order can't be delivered to selected address"));
        } else if (!codAvailable) {
          dispatch(notAllowedPayment('cod', 'Not applicable for this order'));
        } else if (isCODRestricted) {
          dispatch(
            notAllowedPayment(
              'cod',
              CODRestrictedMsg || 'The applied coupon does not support this payment option'
            )
          );
        } else {
          dispatch(enableDisabledPayment('cod'));
        }

        if (value > 0 && Math.abs(orderValue - value) === 0) {
          response = {
            ...response,
            storecredit: {
              paymentType: 'storecredit',
              label: 'Paying Through Wallet'
            }
          };
        }
        if (response.hasOwnProperty('storecredit')) {
          dispatch(updatePaymentOption(response.storecredit));
        }

        if (JPPValue > 0 && Math.abs(orderValue - JPPValue) === 0) {
          response = {
            ...response,
            jioprimepoint: {
              paymentType: 'jioprimepoint',
              label: 'Paying Through Jio Prime Point'
            }
          };
          dispatch(updatePaymentOption(response.jioprimepoint));
        }
        isRequestOrginIsBrowser && dispatch(hideLoader('layout-loader'));
        dispatch(setPaymentOption(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              getPaymentOptions(requestObj)(dispatch);
            })
            .catch(() => {
              showErrorMessageInfo(errorObj, dispatch);
              isRequestOrginIsBrowser && dispatch(hideLoader('cart-loader'));
            });
        });
      });
  };
}

function showErrorMessageInfo(errorObj = {}, dispatch) {
  dispatch(setErrorObject(errorObj));
  const timeOut = setTimeout(() => {
    dispatch(setErrorObject({}));
    clearTimeout(timeOut);
  }, 5000);
}

export function initiatePayment(paymentOption, cb, errorCallBack) {
  return async dispatch => {
    const { retrypayment = false } = paymentOption;
    dispatch(showLoader('layout-loader'));
    let paymentResponse = {};
    if (retrypayment) {
      paymentResponse = await _safePaymentURL(async error => {
        const { statusCode } = error;
        const errorObj = await errorParser(error, statusCode);
        if (statusCode === 401) {
          await _tokenReCreateParser(() => {}, statusCode);
          await initiatePayment(paymentOption, cb, errorCallBack)(dispatch);
          return {};
        }
        dispatch(hideLoader('layout-loader'));
        showErrorMessageInfo(errorObj, dispatch);
      }, paymentOption);
    } else {
      const oosResponse = await _safeCheckStock(async error => {
        /**
         * Stockcheck payment got failed
         */
        const statusCode = getErrorStatusCode(error);
        const errorObj = await errorParser(error, statusCode);
        const { reason = '' } = errorObj;
        if (statusCode === 401) {
          await _tokenReCreateParser(() => {}, statusCode);
          await initiatePayment(paymentOption, cb, errorCallBack)(dispatch);
          return {};
        }
        if (statusCode === 400 && reason.toLowerCase() === 'notfound') {
          errorCallBack && errorCallBack();
        } else {
          showErrorMessageInfo(errorObj, dispatch);
          dispatch(hideLoader('layout-loader'));
        }
        return errorObj || {};
      });
      /**
       * Logic to redirect back to cart page by merging cart
       * with OOS item.
       */
      if (Object.keys(oosResponse).length) {
        // Outofstock error has occured
        const { cartModifications = [] } = oosResponse;
        const outOfStockItems = cartModifications.map(item => {
          const {
            statusCode = '',
            entry: { product: { code = '', url = '', images = [] } = {} } = {}
          } = item;
          if (statusCode == 'noStock' && code) {
            return { code, images, item };
          }
        });
        if (outOfStockItems.length) {
          if (!isNode()) {
            sessionStorage.setItem('OOSItems', JSON.stringify(outOfStockItems));
          }
          dispatch(setOOSItemInCart(outOfStockItems));
        } else {
          sessionStorage.setItem('OOSItemsError', true);
        }
        errorCallBack();
        return;
      }
      paymentResponse = await _safePaymentURL(async error => {
        const { statusCode } = error;
        const errorObj = await errorParser(error, statusCode);
        if (statusCode === 401) {
          await _tokenReCreateParser(() => {}, statusCode);
          await initiatePayment(paymentOption, cb, errorCallBack)(dispatch);
          return {};
        }
        dispatch(hideLoader('layout-loader'));
        showErrorMessageInfo(errorObj, dispatch);
      }, paymentOption);
    }

    if (paymentResponse.paymentType) {
      paymentResponse = { ...paymentResponse, enableAutoSubmit: true };
      dispatch(setGateway(paymentResponse));
      cb(paymentResponse);
      // dispatch(hideLoader("layout-loader"));
    } else {
      paymentResponse.errorType = 'info';
      showErrorMessageInfo(paymentResponse, dispatch);
    }
    return paymentResponse;
  };
}

async function createPaymentURL(paymentOption) {
  let response = await fetcher(
    `/api/checkout/create-gateway-request`,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(paymentOption),
      credentials: 'include'
    })
  );
  response = await _safeFetchGetJSONResHandler(async error => {
    const statusCode = getErrorStatusCode(error);
    const errorObj = await errorParser(error, statusCode);
    return Promise.reject({
      ...errorObj,
      statusCode
    });
  }, response);
  return response;
}

async function checkStock() {
  let response = await fetcher(
    `/api/cart/checkstock`,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: { 'content-type': 'application/json' },
      credentials: 'include'
    })
  );
  response = await _safeFetchGetJSONResHandler(async error => {
    return Promise.reject(error);
  }, response);
  return response;
}

export function createOrder(paymentObj = {}, callback, errorCallBack) {
  return async dispatch => {
    const {
      paymentType: mode = '',
      code: cartId = '',
      retrypayment = false,
      redeemType = ''
    } = paymentObj;

    let response = {};
    let oosResponse = {};
    dispatch(showLoader('layout-loader'));
    if (!retrypayment) {
      oosResponse = await _safeCheckStock(async error => {
        /**
         * Stockcheck payment got failed
         */
        const statusCode = getErrorStatusCode(error);
        const errorObj = await errorParser(error, statusCode);
        const { reason = '' } = errorObj;
        if (statusCode === 401) {
          await _tokenReCreateParser(() => {}, statusCode);
          await createOrder(paymentObj, callback, errorCallBack)(dispatch);
          return {};
        }
        if (statusCode === 400 && reason.toLowerCase() === 'notfound') {
          errorCallBack && errorCallBack();
        } else {
          showErrorMessageInfo(errorObj, dispatch);
          dispatch(hideLoader('layout-loader'));
        }
        return Promise.reject(errorObj || {});
      });
    }

    if (Object.keys(oosResponse).length) {
      // Outofstock error has occured
      const { cartModifications = [] } = oosResponse;
      const outOfStockItems = cartModifications.map(item => {
        const {
          statusCode = '',
          entry: { product: { code = '', url = '', images = [] } = {} } = {}
        } = item;
        if (statusCode == 'noStock' && code) {
          return { code, images, item };
        }
      });
      if (outOfStockItems.length) {
        if (!isNode()) {
          sessionStorage.setItem('OOSItems', JSON.stringify(outOfStockItems));
        }
        dispatch(setOOSItemInCart(outOfStockItems));
      } else {
        sessionStorage.setItem('OOSItemsError', true);
      }
      errorCallBack();
      return;
    }
    if (mode && cartId) {
      response = await fetcher(
        `/api/checkout/place-order`,
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ mode, cartId, redeemType }),
          credentials: 'include'
        })
      );

      response = await _safeFetchGetJSONResHandler(async error => {
        const statusCode = getErrorStatusCode(error);
        const errorObj = await errorParser(error, statusCode);
        if (statusCode === 401) {
          await _tokenReCreateParser(() => {}, statusCode);
          await createOrder(paymentObj, callback, errorCallBack)(dispatch);
          return {};
        }
        dispatch(hideLoader('layout-loader'));
        showErrorMessageInfo(errorObj, dispatch);
        return Promise.reject({
          ...errorObj,
          statusCode
        });
      }, response);
      const { status = '' } = response;
      if (
        status.length &&
        (status.toLowerCase().includes('not sufficient') ||
          status.toLowerCase().includes('insufficient'))
      ) {
        const messageBar = {
          errorType: 'info',
          message: status
        };
        dispatch(hideLoader('layout-loader'));
        showErrorMessageInfo(messageBar, dispatch);
        // callback({reload: true})
      } else {
        dispatch(setOrder(response));
        callback(response);
      }
    }
    return response;
  };
}
